const get = require("lodash/get");
const axios = require("axios");
const { color } = require("./log-colors");

const returnData = (res) => {
  const url = get(res, "config.url", "unknown");

  if (res.status === 204) {
    console.warn(
      color.yellow(`GET ${url} returned 204 No Content — the resource exists but has no data`),
    );
  }
  if (res.status > 204) {
    const msg = `GET ${url} failed — status ${res.status} (${res.statusText || "no status text"})`;
    console.error(color.red(msg));
    throw Error(msg);
  }

  return res.data;
};

module.exports = (url, headers) => {
  const printError = (error) =>
    console.error(
      color.red(`GET ${url} Failed to get a response from server, headers: ${
        headers ? headers : "None"
      }, error: ${error}`),
    );
  if (headers) {
    return axios
      .get(url, { headers })
      .then(returnData)
      .catch((error) => {
        printError(error);
        throw error;
      });
  } else {
    return axios
      .get(url)
      .then(returnData)
      .catch((error) => {
        printError(error);
        throw error;
      });
  }
};
